"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Router = void 0;
var Error_1 = require("./Error");
var Policy_1 = require("./Policy");
var Query_1 = require("./Query");
var ValueStore_1 = require("./ValueStore");
var Router = (function () {
    function Router(history, _a) {
        var base = (_a === void 0 ? {} : _a).base;
        this.routes = [];
        this.base = getBase(base);
        this.history = history;
        this.query = new Query_1.Query(history);
        this.params = new ValueStore_1.ValueStore();
        this.state = new ValueStore_1.ValueStore();
    }
    Object.defineProperty(Router.prototype, "location", {
        get: function () {
            return this.history.location;
        },
        enumerable: false,
        configurable: true
    });
    Router.prototype.register = function (routes) {
        for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
            var route = routes_1[_i];
            this.routes.push(route.base(this.base));
        }
        return this;
    };
    Router.prototype.listen = function (options) {
        var _this = this;
        var locations = [];
        if (this.unregister) {
            this.unregister();
        }
        this.unregister = this.history.listen(function (_a) {
            var location = _a.location;
            return __awaiter(_this, void 0, void 0, function () {
                var result, route, state, query, params, _i, _b, policy, res, err_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (locations.length > 1) {
                                locations.shift();
                            }
                            locations.push(location);
                            result = this.get(location.pathname);
                            if (!result) return [3, 7];
                            route = result.route;
                            state = new ValueStore_1.ValueStore(location.state);
                            query = new Query_1.Query(this.history, location.search);
                            params = getParams(result);
                            _i = 0, _b = route.policies;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _b.length)) return [3, 6];
                            policy = _b[_i];
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, 4, , 5]);
                            return [4, policy.call(Policy_1.responses, { route: route, query: query, params: params, state: state })];
                        case 3:
                            res = _c.sent();
                            switch (res.status) {
                                case "accept": {
                                    break;
                                }
                                case "reject": {
                                    return [2, options.error(new Error_1.RouterError(res.message, res.details))];
                                }
                                case "redirect": {
                                    if (res.isExternal) {
                                        return [2, window.location.replace(res.path)];
                                    }
                                    return [2, this.goTo(res.path, { origin: locations[0] })];
                                }
                            }
                            return [3, 5];
                        case 4:
                            err_1 = _c.sent();
                            return [2, options.error(err_1)];
                        case 5:
                            _i++;
                            return [3, 1];
                        case 6:
                            this.route = route;
                            this.state = state;
                            this.query = query;
                            this.params = params;
                            options.render(route, location).catch(options.error);
                            return [3, 8];
                        case 7:
                            options.error(new Error_1.RouterError("Route does not exist, or has been moved to another location.", {
                                status: 404,
                                code: "ROUTE_NOT_FOUND"
                            }));
                            _c.label = 8;
                        case 8: return [2];
                    }
                });
            });
        });
        return this;
    };
    Router.prototype.goTo = function (path, state) {
        if (state === void 0) { state = {}; }
        this.history.push((this.base + path.replace(this.base, "")).replace(/\/$/, ""), state);
    };
    Router.prototype.get = function (path) {
        for (var _i = 0, _a = this.routes; _i < _a.length; _i++) {
            var route = _a[_i];
            var match = route.match(path);
            if (match) {
                return { route: route, match: match };
            }
        }
        return undefined;
    };
    return Router;
}());
exports.Router = Router;
function getParams(container) {
    var params = container.route.params;
    var result = {};
    var index = 1;
    for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
        var param = params_1[_i];
        result[param.name] = container.match[index];
        index += 1;
    }
    return new ValueStore_1.ValueStore(result);
}
function getBase(path) {
    if (!path || path === "" || path === "/") {
        return "";
    }
    return path;
}
